import request from '@/request/request'
let baseURL =  global.$config.api.system_url + '/emergency-server/'
// 新增医疗机构
export function save(data) {
    return request({
        baseURL,
        url: '/emergencyMedicalInstitution/save',
        method: 'post',
        data
    })
}
//修改医疗机构
export function update(data) {
    return request({
        baseURL,
        url: '/emergencyMedicalInstitution/update',
        method: 'post',
        data
    })
}
//查询医疗机构列表
export function list(params) {
    return request({
        baseURL,
        url: '/emergencyMedicalInstitution/list',
        method: 'get',
        params
    })
}
//查询医疗机构
export function detail(id) {
    return request({
        baseURL,
        url: '/emergencyMedicalInstitution/detail?id=' + id,
        method: 'get',
    })
}
//删除医疗机构
export function remove(data) {
    return request({
        baseURL,
        url: '/emergencyMedicalInstitution/remove',
        method: 'post',
        data: { ...data, isFormData:true }
    })
}